// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + (chunkId === 66586 ? "griffel" : chunkId) + "-" + {"66586":"792d2498c7","94965":"e6aaf522e5"}[chunkId] + ".css";
};